<template>
    <div class="advanced_preview" :style="wrapStyle" ref="wrap">
        <div class="advanced_preview__dom" :class="{ 'disabled': domItem.disabled }" @click="onSelectDom(domItem, domIndex)" v-for="(domItem, domIndex) in domList" :key="domIndex" :style="getDomStyle(domItem.style)">
            <div class="advanced_preview__text" :style="getTextStyle(domItem.style)" v-if="domItem.type == 1">
                <template v-if="domItem.style.firstFontSize">
                    <span :style="getFirstStyle(domItem)">{{ domItem.text.substring(0, 1) }}</span>
                    <span>{{ domItem.text.substring(1) }}</span>
                </template>
                <template v-else>{{ domItem.text }}</template>
            </div>
            <img v-if="domItem.type == 2" :src="domItem.content | urlCDN(domItem.isTempImg, tenantId)" width="100%" height="100%" alt="">
            <div class="active">
                <span class="active_border"></span>
                <span class="active_left"></span>
                <span class="active_right"></span>
            </div>
        </div>
        <div class="advanced_preview__active" :style="activeStyleData" @mousedown="onMouseDown">
            <span class="active_left"></span>
            <span class="active_right"></span>
        </div>
    </div>
</template>
<script>
    
    import ImageMixins from './mixins/imageUtils'
    const flexAlignMap = {
        'left': 'flex-start',
        'center': 'center',
        'right': 'flex-end'
    }
    export default {
        name: 'advancedPreview',
        mixins: [ ImageMixins ],
        props: {
            moduleData: Object,
            defaultActiveIndex: Number,
            parentShopId: Number,
            multiple: Number,
        },
        data() {
            return {
                activeIndex: null,
            }
        },
        watch: {
            defaultActiveIndex: {
                handler(newVal) {
                    this.activeIndex = newVal;
                },
                immediate: true,
            },
            parentShopId: {
                handler(newVal) {
                    this.tenantId = newVal;
                },
                immediate: true,
            },
        },
        computed: {
            activeStyleData() {
                const domData = this.moduleData.domList[this.activeIndex];
                if (!domData) {
                    return { 
                        display: 'none',
                    }
                }
                const styleData = this.getDomStyle(domData.style);
                if (domData.style.actionIndex) {
                    styleData.zIndex = domData.style.actionIndex;
                }
                return styleData;
            },
            domList() {
                const { domList } = this.moduleData;
                if (!domList) return [];
                const actionList = domList.map((item, index) => {
                    const newItem = JSON.parse(JSON.stringify(item));
                    newItem.domIndex = index;
                    newItem.type = 3;
                    newItem.disabled = item.disabled;
                    if (item.actionIndex) {
                        newItem.style.zIndex = item.actionIndex;
                    }
                    return newItem;
                }).filter(item => item.actionIndex !== undefined)
                return domList.concat(actionList)
            },
            wrapStyle() {
                const { picSize } = this.moduleData;
                const [ width, height ] = picSize;
                return {
                    height: this.getPxValueForNumber(height),
                    width: this.getPxValueForNumber(width),
                }
            }
        },
        methods: {
            getPxValueForNumber(value, defaultValue = 'auto') {
                if (isNaN(Number(value))) return undefined;
                return value > 0 ? `${value/this.multiple}px` : defaultValue;
            },
            clearSelect() {
                this.activeIndex = null;
            },
            onSelectDom(domData, index) {
                if (domData.disabled) return;
                const domIndex = domData.domIndex !== undefined  ? domData.domIndex : index;
                this.activeIndex = domIndex
                this.$emit('select', {domData: this.moduleData.domList[domIndex], domIndex});
            },
            getFirstStyle(domItem) {
                const { firstFontSize } = domItem.style;
                return {
                    fontSize: this.getPxValueForNumber(firstFontSize)
                }
            },
            onMouseMove(e) {
                const domData = this.moveDomData;
                if (!domData || domData.disabled) return;
                const { shiftX, shiftY, maxLeft, maxTop } = domData;
                const { pageX, pageY } = e;
                const { left, top } = this.$refs.wrap.getBoundingClientRect();
                let newLeft = pageX - window.scrollX - left - shiftX;
                let newTop = pageY - window.scrollY - top - shiftY;
                if (newLeft > maxLeft) {
                    newLeft = maxLeft;
                }
                if (newTop > maxTop) {
                    newTop = maxTop;
                }
                domData.style.left = Math.max(newLeft * (this.multiple || 2), 0);
                domData.style.top = Math.max(newTop * (this.multiple || 2), 0);
            },
            onMouseDown(e) {
                const domData = this.moduleData.domList[this.activeIndex];
                if (domData.disabled) return;
                const touchNode = e.target;
                const rectData = touchNode.getBoundingClientRect();
                const shiftX = e.clientX - rectData.left;
                const shiftY = e.clientY - rectData.top;
                domData.shiftY = shiftY;
                domData.shiftX = shiftX;
                const { width: previewWidth, height: previewHeight } = this.$refs.wrap.getBoundingClientRect();
                domData.maxLeft = previewWidth - rectData.width;
                domData.maxTop = previewHeight - rectData.height;
                this.moveDomData = domData;
                document.addEventListener('mousemove', this.onMouseMove);
                document.addEventListener('mouseup', this.onMouseUp)
            },
            onMouseUp() {
                document.removeEventListener('mousemove', this.onMouseMove);
                document.removeEventListener('mouseup', this.onMouseUp);
                this.moveDomData = null;
                const domData = this.moduleData.domList[this.activeIndex];
                if (!domData) return;
                delete domData.shiftY;
                delete domData.shiftX;
                delete domData.maxLeft;
                delete domData.maxTop;
            },
            getTextStyle(style) {
                const { textAlign } = style;
                return {
                    justifyContent: flexAlignMap[textAlign]
                }
            },
            getDomStyle(style) {
                const { fontSize, width, height, left, top, paddingTop, paddingRight, paddingBottom, paddingLeft, lineHeight, letterSpacing, bottom } = style;
                const data = {
                    textAlign: 'center',
                    ...style,
                    fontSize: this.getPxValueForNumber(fontSize),
                    width: this.getPxValueForNumber(width),
                    height: this.getPxValueForNumber(height),
                    left: this.getPxValueForNumber(left),
                    top: bottom === undefined ? this.getPxValueForNumber(top) : undefined,
                    bottom,
                    paddingTop: this.getPxValueForNumber(paddingTop),
                    paddingRight: this.getPxValueForNumber(paddingRight),
                    paddingBottom: this.getPxValueForNumber(paddingBottom),
                    paddingLeft: this.getPxValueForNumber(paddingLeft),
                    lineHeight: this.getPxValueForNumber(lineHeight, 'normal'),
                    letterSpacing: this.getPxValueForNumber(letterSpacing, 'normal'),
                }
                return data;
            },
        },
    }
</script>
<style>
    .advanced_preview {
        position: relative;
        border: 1px dashed #dedede;
    }
    .advanced_preview__text {
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
    }
    .advanced_preview__dom {
        position: absolute;
        box-sizing: border-box;
        user-select: none;
    }
    .advanced_preview__dom img {
        vertical-align: top;
    }
    .advanced_preview__dom .active {
        display: none;
    }
    .advanced_preview__dom .active_border {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }
    .advanced_preview__dom:not(.disabled) {
        cursor: pointer;
    }
    .advanced_preview__dom:not(.disabled):hover .active {
        display: block;
    }
    .advanced_preview__active,
    .advanced_preview__dom .active_border {
        position: absolute;
        border: 2px solid #2581FF;
        box-sizing: border-box;
        cursor: pointer;
    }
    .active_left::before,
    .active_right::before,
    .active_left::after,
    .active_right::after {
        content: ' ';
        position: absolute;
        width: 7px;
        height: 7px;
        border: 1px solid #2581FF;
        background: #fff;
        box-sizing: border-box;
    }
    .active_left::after,
    .active_right::after {
        bottom: -4px;
    }
    .active_left::before,
    .active_right::before {
        top: -4px;
    }
    .active_right::before,
    .active_right::after {
        right: -4px;
    }
    .active_left::before,
    .active_left::after {
        left: -4px;
    }
    .advanced_preview__dom .active_left::after,
    .advanced_preview__dom .active_right::after {
        bottom: -2px;
    }
    .advanced_preview__dom .active_left::before,
    .advanced_preview__dom .active_right::before {
        top: -2px;
    }
    .advanced_preview__dom .active_right::before,
    .advanced_preview__dom .active_right::after {
        right: -2px;
    }
    .advanced_preview__dom .active_left::before,
    .advanced_preview__dom .active_left::after {
        left: -2px;
    }
</style>